import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    useQueueSystem: sessionStorage.getItem('useQueueSystem') === '1'
  },
  getters: {
    useQueueSystem: state => state.useQueueSystem
  },
  mutations: {
    SET_USE_QUEUE_SYSTEM(state, value) {
      state.useQueueSystem = value === 1 || value === '1'
      if (value === 1 || value === '1') {
        sessionStorage.setItem('useQueueSystem', '1')
      } else {
        sessionStorage.setItem('useQueueSystem', '0')
      }
    }
  },
  actions: {
  },
  modules: {
  }
})
